import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { clientPhaseLabel, inboxSubject } from "../../shared/inquiry";
import { displayStamp } from "../../shared/overview";
import { api } from "../api";
import { useSession } from "../App";
import { hasPermission } from "../../shared/permissions";
import { Banner, messageOf } from "./ui";

type Inquiry = { id: string; channel: string; subject: string | null; processing_state: string; title: string | null; sales_stage: string | null; card_step: number | null; event_id: string | null; created_at: string };

export function InboxPage() {
  const { user } = useSession();
  const reception = user.role === "reception";
  const [inquiries, setInquiries] = useState<Inquiry[] | null>(null);
  const [raw, setRaw] = useState("From: guest@example.com\nSubject: Saturday in June\nMessage-ID: <demo-june@example.com>\n\nAround 40 adults in Kolonaki in June.");
  const [error, setError] = useState<string | null>(null);
  const [note, setNote] = useState<string | null>(null);

  function load() {
    api<{ inquiries: Inquiry[] }>("/api/inquiries")
      .then((result) => setInquiries(result.inquiries))
      .catch((reason: unknown) => setError(messageOf(reason)));
  }

  useEffect(load, []);

  return (
    <>
      <header className="page-head">
        <div>
          <h1>Εισερχόμενα</h1>
        </div>
        {reception || !hasPermission(user.role, user.permissions, "imports.write") ? null : <Link className="button" to="/imports">Εισαγωγή φύλλου</Link>}
      </header>
      <Banner error={error} note={note} />
      {!inquiries && !error ? <p>Φόρτωση αιτημάτων…</p> : null}
      {inquiries && inquiries.length === 0 ? <p>Τα εισερχόμενα είναι άδεια.</p> : null}
      <ul className="inbox-list">
        {(inquiries ?? []).map((item) => {
          return (
            <li className="inbox-item" key={item.id}>
              <div className="inbox-meta">
                <span className="pill">{item.channel}</span>
                <time dateTime={item.created_at}>{displayStamp(item.created_at)}</time>
              </div>
              <strong>{item.event_id ? <Link to={`/inbox/${item.id}`}>{inboxSubject(item.channel, item.subject)}</Link> : inboxSubject(item.channel, item.subject)}</strong>
              <span className="meta">{item.processing_state.replace(/_/g, " ")}</span>
              {item.event_id ? <Link to={`/inbox/${item.id}`}>Στοιχεία εκδήλωσης · {clientPhaseLabel(item.card_step, item.sales_stage)}</Link> : <span className="meta">Χωρίς σύνδεση</span>}
            </li>
          );
        })}
      </ul>
      {reception ? null : <form
        className="panel"
        style={{ marginTop: 16 }}
        onSubmit={(event) => {
          event.preventDefault();
          setError(null);
          void api("/api/intake/email", { method: "POST", body: JSON.stringify({ raw }) })
            .then(() => {
              setNote("Το μήνυμα αποθηκεύτηκε και μπήκε στην ουρά. Δεν παραδόθηκε σε γραμματοκιβώτιο.");
              load();
            })
            .catch((reason: unknown) => setError(messageOf(reason)));
        }}
      >
        <h2>Επικόλληση μηνύματος</h2>
        <textarea value={raw} onChange={(event) => setRaw(event.target.value)} />
        <button type="submit">Τοπική επεξεργασία</button>
      </form>}
    </>
  );
}
